import { ChangeDetectionStrategy, Component, HostBinding, Input } from '@angular/core';
import { RegularDateFormatMMMdy } from '@anecdotes/helpers';

@Component({
  selector: 'app-last-published-info',
  templateUrl: './last-published-info.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class LastPublishedInfoComponent {
  @HostBinding('class')
  private readonly classes = 'flex gap-2 items-center h-full pr-3 border-r border-solid border-navy-40 leading-loose';

  protected readonly dateFormat = RegularDateFormatMMMdy;

  @Input({ required: true })
  lastPublished: string | Date;

  @Input({ required: true })
  hasPendingChanges: boolean;

  buildTranslationKey(key: string): string {
    return `trustCenter.lastPublishedInfo.${key}`;
  }
}
